export const NEW_ENTRY_ID = 'new';

export const SERVICE_FEE_ALERT_TYPES = {
  SERVICE_FEE_DUE: 'service_fee_due',
  SERVICE_FEE_OVERDUE: 'service_fee_overdue',
  SERVICE_FEE_CANCELLED: 'service_fee_cancelled',
} as const;

export type ServiceFeeAlertType =
  (typeof SERVICE_FEE_ALERT_TYPES)[keyof typeof SERVICE_FEE_ALERT_TYPES];

export const SERVICE_FEE_ALERT_STATUSES = {
  ACTION_REQUIRED: 'action_required',
  INFO: 'info',
  WARNING: 'warning',
} as const;

export type ServiceFeeAlertStatusType =
  (typeof SERVICE_FEE_ALERT_STATUSES)[keyof typeof SERVICE_FEE_ALERT_STATUSES];

// Display-only, non-service-fee alerts rendered as a gray banner (status: 'info').
// Kept distinct from SERVICE_FEE_ALERT_TYPES so they never trigger the service-fee
// behaviors (Pay Service Fee button, navigation blocking).
export const CONTEST_INFO_ALERT_TYPES = {
  CONTEST_RESTARTED: 'contest_restarted',
} as const;

export type ContestInfoAlertType =
  (typeof CONTEST_INFO_ALERT_TYPES)[keyof typeof CONTEST_INFO_ALERT_TYPES];
